import { z } from 'zod';
export const createVenueSchema = z.object({
    name: z.string().min(1).max(255),
    address: z.string().max(500).optional(),
    city: z.string().max(100).optional(),
    state: z.string().max(100).optional(),
    zipCode: z.string().max(20).optional(),
    country: z.string().max(100).optional(),
    phone: z.string().max(50).optional(),
    email: z.string().email().optional(),
    contactId: z.string().uuid().optional(),
    vendorId: z.string().uuid().nullable().optional(),
    capacity: z.number().int().positive().optional(),
    priceRange: z.string().max(100).optional(),
    notes: z.string().max(2000).optional(),
});
// Update fields are nullable: the edit panels send null to clear a field
export const updateVenueSchema = z.object({
    name: z.string().min(1).max(255).optional(),
    address: z.string().max(500).nullable().optional(),
    city: z.string().max(100).nullable().optional(),
    state: z.string().max(100).nullable().optional(),
    zipCode: z.string().max(20).nullable().optional(),
    country: z.string().max(100).nullable().optional(),
    phone: z.string().max(50).nullable().optional(),
    email: z.string().email().nullable().optional(),
    contactId: z.string().uuid().nullable().optional(),
    vendorId: z.string().uuid().nullable().optional(),
    capacity: z.number().int().positive().nullable().optional(),
    priceRange: z.string().max(100).nullable().optional(),
    notes: z.string().max(2000).nullable().optional(),
    isActive: z.boolean().optional(),
});
// ─── Venue Contacts ─────────────────────────────────────────────────────────
export const addVenueContactSchema = z.object({
    userId: z.string().uuid(),
    title: z.string().min(1).max(100),
    isPrimary: z.boolean().optional(),
    sortOrder: z.number().int().optional(),
});
export const updateVenueContactSchema = z.object({
    title: z.string().min(1).max(100).optional(),
    isPrimary: z.boolean().optional(),
    sortOrder: z.number().int().optional(),
});
//# sourceMappingURL=venue.js.map